import { render, staticRenderFns } from "./DialogAppConfig.vue?vue&type=template&id=390aa788&scoped=true&lang=pug"
import script from "./DialogAppConfig.vue?vue&type=script&lang=js"
export * from "./DialogAppConfig.vue?vue&type=script&lang=js"
import style0 from "./DialogAppConfig.vue?vue&type=style&index=0&id=390aa788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390aa788",
  null
  
)

export default component.exports